// The files in the platform agent's message box (D6, docs/platform-agent/contracts.md §8). The label, placeholder
// and hint stay in PlatformAgentConversation's `composer`.
export default {
  drop: 'Dateien hier ablegen: PDF, Fotos, Excel, CSV oder Word',
  waiting: 'Gesendet wird, sobald die Dateien hochgeladen sind.',
  // A message sent while New chat is starting waits for the new chat (QA90).
  starting: 'Einen Moment: Der neue Chat startet, und deine Nachricht geht dorthin.',
  // A message that waits for the person to deal with a file that can't go with it (QA121).
  blocked: {
    refused: 'Entferne die Datei, die nicht gesendet werden kann, und sende dann deine Nachricht.',
    failed: 'Lade die Datei noch einmal hoch oder entferne sie, und sende dann deine Nachricht.',
  },
  // A PDF's pages on its tile (B37): "PDF · 1,2 MB · 4 Seiten".
  pages_one: '{{count}} Seite',
  pages_other: '{{count}} Seiten',
  problems: {
    type: 'Diese Art von Datei kann nicht gesendet werden. Schick ein PDF, ein Foto (JPG, PNG oder HEIC) oder eine Excel-, CSV- oder Word-Datei.',
    size: 'Über 20 MB. Eine Datei darf höchstens 20 MB groß sein.',
    empty: 'Diese Datei ist leer.',
    count: 'Bis zu 10 Dateien pro Nachricht.',
    upload: 'Der Upload wurde abgebrochen. Versuch es noch mal.',
  },
};
